import { AccountTransaction, FinancialContract } from '@akiba/models_beta_temp';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-approve-deny',
  templateUrl: './approve-deny.component.html',
  styleUrls: ['./approve-deny.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ApproveDenyComponent implements OnInit {

  showError: boolean = false;

  @Input() approved!: boolean;
  @Input() financialContract: FinancialContract | undefined;
  @Input() accountTransaction: AccountTransaction | undefined;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  resolution(): void {

    if (!this.accountTransaction && !this.financialContract) {
      this.showError = true;
      return;
    }

    if (this.financialContract) {

      if (this.financialContract.comment === '') {
        this.showError = true;
        return;
      }

      this.activeModal.close(this.financialContract);

    } else if (this.accountTransaction) {

      if (this.accountTransaction.comment === '') {
        this.showError = true;
        return;
      }

      this.activeModal.close(this.accountTransaction);

    }

  }

}
